import * as actionTypes from '../actions/types';

const initialState = {
    prestadorActivo: null,
    token: null,
    alertarPrestador: false
};

export function authReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.SET_PRESTADOR_ACTIVO:
            return {
                ...state,
                prestadorActivo: { ...action.payload },
            };
        case actionTypes.SET_TOKEN:
            return {
                ...state,
                token: action.payload,
            };
        case actionTypes.SET_ALERTA_PRESTADOR:
            return {
                ...state,
                alertarPrestador: action.payload,
            };
        default:
            return state;
    }
}
